import firebaseApp from './firebase';

export default firebaseApp;
